import React from 'react';
import PropTypes from 'prop-types';

import Modal from './index';
import Icon from '../Icon';
import './styles.css';

const ClosableModal = (props) => {
  const { children, ...rest } = props;
  return (
    <Modal
      {...rest}
      closeIcon={<Icon name="close" styleName="modal-close" />}
    >
      {children}
    </Modal>
  );
};

ClosableModal.propTypes = {
  children: PropTypes.node,
};

export default ClosableModal;
